// extracted by mini-css-extract-plugin
module.exports =  {"container":"HKGxWg7lZCKSiSSTeCP0","boardGridContainer":"TTMHy6xb6M0JDk7ggY6R"};